export default {
  defaultDisplayName: 'Nowy sygnał wirtualny',
};
